import fetch from "cross-fetch";

import {getBigDataApiPath} from "../../../../../../utils/get_big_data_api_path";

export const fetchLastAvailableEntry = async (): Promise<{currentDate: string; completeData: boolean}> => {
    const fetchDateUrl = `${getBigDataApiPath()}charts/current-date/`;
    const lastAvailableDate = await fetch(fetchDateUrl);
    const {date, complete_data} = await lastAvailableDate.json();
    if (!date) {
        throw new Error(`fetchLastAvailableDate: cannot find date in URL: ${fetchDateUrl}`);
    }
    return {currentDate: date, completeData: complete_data};
};
